<template>
    <ESelect
        v-model="choiceEle"
        multiple
        collapse-tags
        filterable
        :filter-method="SearchFilter"
        placeholder="请选择"
        :style="{width: width + 'px'}"
        class="de-tags-select-mul"
        ref="allSelect"
        clearable
        @visible-change="handleVisible"
        @change="handleChange"
    >
        <div :style="{cursor: 'pointer', paddingLeft: '20px', marginBottom: '6px', color: '#409EFF'}">
            <span :style="{display: 'inline-block'}"  @click="handleAllSelect('all')">全选</span>
            <span :style="{display: 'inline-block', marginLeft: '10px'}" @click="handleAllSelect('cancel')">取消全选</span>
        </div>
        <template v-if="virtual">
            <VirtualList
                ref="virtualList"
                data-key="uid"
                style="max-height: 245px; overflow-y: auto;"
                :data-sources="optionList"
                :data-component="itemComponent"
                :keeps="20"
                :estimate-size="50"
                class="detagWidth"
            />
        </template>
        <template v-else>
            <el-option :label="option.name" :value="option.id"
                       v-for="option in optionList" :key="option.id"></el-option>
        </template>
    </ESelect>
</template>

<script>
/**
 *
 */
import VirtualList from 'vue-virtual-scroll-list';
import OptionsItem from './virtualListItem';
import {uniq} from 'lodash'
export default {
    name: 'SelectAll',
    components: {
        VirtualList
    },
    props: {
        options: {
            type: Array,
            default: () => {
                return [];
            }
        },
        width: {
            type: Number,
            default: 180
        },
        lineHeight: {
            type: Number,
            default: 28
        },
        checkStrictly: {
            type: Boolean,
            default: false
        },
        filterable: {
            type: Boolean,
            default: true
        },
        size: {
            type: String,
            default: "mini"
        },
        value: {
            type: [Array,String],
            default: () => {
                return [];
            }
        },
        virtual: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            optionList: [],
            lastSelectedList: [],
            choiceEle: [],
            itemComponent: OptionsItem,
        }
    },
    watch: {
        'options': {
            handler(n, o){
                this.optionList = n
            },
            deep:true,
            immediate: true
        },
        'value': {
            handler(n, o){
                this.choiceEle = n ? n :[]
            },
            immediate: true
        },
    },
    mounted() {

    },
    methods: {
        handleVisible(value) {
            if(!value) {
                this.optionList = []
                this.optionList = this.options
                if(this.virtual) {
                    this.$refs.virtualList.reset()
                }
            }
        },
        SearchFilter(val) {
            this.optionList = this.options.filter(item=> {
                return item.name.toLowerCase().indexOf(val.toLowerCase()) > -1
            }
            )
        },
        handleAllSelect(type) {
            if(type == 'all') {
                let append = this.optionList.map(item=>item.id)
                this.choiceEle = uniq([...this.choiceEle, ...append])
            }else{
                let optionList_ids = this.optionList.map(item=>item.id)
                let channel_ids = this.choiceEle.filter(item=> !optionList_ids.includes(item))
                this.choiceEle = [...channel_ids]
            }
            this.$refs['allSelect'].blur()
            this.$emit('input', this.choiceEle)
        },
        handleChange(value) {
            this.choiceEle = value
            this.$emit('input', value)
        }
    }
};
</script>

<style lang="scss">
.de-tags-select-mul {
    .el-select__tags{
        height: 22px;
        white-space: nowrap;
        overflow:hidden;
        flex-wrap: nowrap;
    }
    .el-select__tags-text{
        display: inline-block;
        max-width: 85px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}
</style>

